<template>
  <register-umkm-component />
</template>
      
  <script>
import RegisterUmkmComponent from "../components/register-umkm/Index.vue";

export default {
  name: "Login",
  components: {
    RegisterUmkmComponent,
  },
  data: () => ({}),
};
</script>
      
  <style>
</style>